// src/services/salesService.jsx
import axiosInstance from './axiosConfig';

const salesService = {
  getAll: async (page = 1, limit = 100) => {
    const response = await axiosInstance.get(`/sales?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // NEW METHOD - Get all sales invoices for filtering
  getAllSales: async () => {
    try {
      // Request a very high limit to get all records at once
      // Using the new sales-invoice endpoint
      const response = await axiosInstance.get(`/sales/sales-invoice?page=1&limit=10000`);
      return response.data.data ?? response.data;
    } catch (error) {
      console.error('Error fetching all sales invoices:', error);
      throw error;
    }
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/sales/${id}`);
    return response.data.data ?? response.data;
  },

  getActiveInventories: async () => {
    const response = await axiosInstance.get('/inventories/active');
    return response.data.data ?? response.data;
  },

  getActiveCategories: async () => {
    const response = await axiosInstance.get('/categories/active');
    return response.data.data ?? response.data;
  },

  // Get all stock-in records (for filtering categories and products)
  getAllStockIn: async (page = 1, limit = 1000) => {
    const response = await axiosInstance.get(`/stocks/stock-in?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  // Get current stock inventory from /stocks endpoint
  getStocks: async () => {
    const response = await axiosInstance.get(`/stocks`);
    return response.data.data ?? response.data;
  },

  getEmployees: async () => {
    const response = await axiosInstance.get('/employees');
    return response.data.data ?? response.data;
  },

  getCustomers: async () => {
    const response = await axiosInstance.get('/customers');
    return response.data.data ?? response.data;
  },

  create: async (payload) => {
    const response = await axiosInstance.post('/sales/create/admin', payload);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/sales/edit/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/sales/delete/${id}`);
    return response.data;
  },
};

export default salesService;